export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? ''

const ADMIN_BASE_URL_OVERRIDE = (import.meta.env.VITE_ADMIN_BASE_URL as string | undefined) ?? ''

export function getLegacyAdminBaseUrl(): string {
  if (ADMIN_BASE_URL_OVERRIDE) return ADMIN_BASE_URL_OVERRIDE.replace(/\/$/, '')
  if (!API_BASE_URL) return 'https://admin.leckerorder.com'
  return API_BASE_URL.replace(/^https?:\/\/api\./, (m) => m.replace('api.', 'admin.')).replace(/\/$/, '')
}
